import React, { FC, useCallback, useMemo, useReducer } from 'react'
import { AutoComplete } from 'antd'

import { debounce } from 'lodash'
import { isResponseCodeSuccess } from '@/tools'
import { GET_BRAND_LIST } from '@/api/MaterialApi'

interface Props {
  value?: string
  onChange?: (value: string) => void
  placeholder?: string
  style?: React.CSSProperties
  disabled?: boolean
}

interface BrandOption {
  value: string
  label: string
  key: string
}

interface State {
  options: BrandOption[]
  loading: boolean
  searchValue: string
}

type Action =
  | { type: 'setOptions'; payload: BrandOption[] }
  | { type: 'setLoading'; payload: boolean }
  | { type: 'setSearchValue'; payload: string }
  | { type: 'reset' }

const initialState: State = {
  options: [],
  loading: false,
  searchValue: '',
}

function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'setOptions':
      return { ...state, options: action.payload }
    case 'setLoading':
      return { ...state, loading: action.payload }
    case 'setSearchValue':
      return { ...state, searchValue: action.payload }
    case 'reset':
      return initialState
    default:
      return state
  }
}

const BrandSelect: FC<Props> = ({
  value,
  onChange,
  placeholder = '请选择品牌',
  style,
  disabled,
}) => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { options, loading } = state

  // 获取品牌列表（按输入值检索，支持自由输入）
  const getBrandList = useCallback(async (searchText: string) => {
    dispatch({ type: 'setLoading', payload: true })
    const params = {
      name: searchText,
      pageNo: 1,
      pageSize: 10,
    }
    try {
      const res = await GET_BRAND_LIST(params)
      if (isResponseCodeSuccess(res.code)) {
        const list: BrandOption[] = (res.data?.content ?? []).map(
          (item: { brandCode: string; fullName: string }) => ({
            value: item.fullName,
            label: item.fullName,
            key: item.brandCode,
          }),
        )
        dispatch({ type: 'setOptions', payload: list })
      } else {
        dispatch({ type: 'setOptions', payload: [] })
      }
    } finally {
      dispatch({ type: 'setLoading', payload: false })
    }
  }, [])

  // 搜索输入时请求备选品牌（防抖）
  const handleSearch = async (val: string) => {
    dispatch({ type: 'setSearchValue', payload: val })
    if (val) {
      dispatch({ type: 'setOptions', payload: [] })
      await getBrandList(val)
    } else {
      dispatch({ type: 'setOptions', payload: [] })
    }
  }
  const debouncedSearch = useMemo(() => debounce(handleSearch, 200), [])

  // 选择候选项
  const handleSelect = (val: string) => {
    onChange?.(val)
  }

  // 直接输入也能回写到表单
  const handleChange = (val: string) => {
    onChange?.(val)
  }

  // 关闭下拉时重置候选数据
  const handleDropdownVisibleChange = (open: boolean) => {
    if (!open) {
      dispatch({ type: 'reset' })
    }
  }

  return (
    <AutoComplete
      style={style}
      value={value}
      disabled={disabled}
      allowClear
      placeholder={placeholder}
      options={options}
      onSearch={debouncedSearch}
      onChange={handleChange}
      onSelect={handleSelect}
      getPopupContainer={() => document.body}
      notFoundContent={loading && '加载中...'}
      onDropdownVisibleChange={handleDropdownVisibleChange}
      dropdownStyle={{ maxHeight: '400px', overflowY: 'auto' }}
      filterOption={false}
      maxLength={100}
    />
  )
}

export default BrandSelect
import React, { FC, useCallback, useMemo, useReducer } from 'react'
import { AutoComplete } from 'antd'

import { debounce } from 'lodash'
import { isResponseCodeSuccess } from '@/tools'
import { GET_BRAND_LIST } from '@/api/MaterialApi'

interface Props {
  value?: string
  onChange?: (value: string) => void
  placeholder?: string
  style?: React.CSSProperties
  disabled?: boolean
}

interface BrandOption {
  value: string
  label: string
  key: string
}

interface State {
  options: BrandOption[]
  loading: boolean
  searchValue: string
}

type Action =
  | { type: 'setOptions'; payload: BrandOption[] }
  | { type: 'setLoading'; payload: boolean }
  | { type: 'setSearchValue'; payload: string }
  | { type: 'reset' }

const initialState: State = {
  options: [],
  loading: false,
  searchValue: '',
}

function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'setOptions':
      return { ...state, options: action.payload }
    case 'setLoading':
      return { ...state, loading: action.payload }
    case 'setSearchValue':
      return { ...state, searchValue: action.payload }
    case 'reset':
      return initialState
    default:
      return state
  }
}

const BrandSelect: FC<Props> = ({
  value,
  onChange,
  placeholder = '请选择品牌',
  style,
  disabled,
}) => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { options, loading } = state

  // 获取品牌列表（按输入值检索，支持自由输入）
  const getBrandList = useCallback(async (searchText: string) => {
    dispatch({ type: 'setLoading', payload: true })
    const params = {
      name: searchText,
      pageNo: 1,
      pageSize: 10,
    }
    try {
      const res = await GET_BRAND_LIST(params)
      if (isResponseCodeSuccess(res.code)) {
        const list: BrandOption[] = (res.data?.content ?? []).map(
          (item: { brandCode: string; fullName: string }) => ({
            value: item.fullName,
            label: item.fullName,
            key: item.brandCode,
          }),
        )
        dispatch({ type: 'setOptions', payload: list })
      } else {
        dispatch({ type: 'setOptions', payload: [] })
      }
    } finally {
      dispatch({ type: 'setLoading', payload: false })
    }
  }, [])

  // 搜索输入时请求备选品牌（防抖）
  const handleSearch = async (val: string) => {
    dispatch({ type: 'setSearchValue', payload: val })
    if (val) {
      dispatch({ type: 'setOptions', payload: [] })
      await getBrandList(val)
    } else {
      dispatch({ type: 'setOptions', payload: [] })
    }
  }
  const debouncedSearch = useMemo(() => debounce(handleSearch, 200), [])

  // 选择候选项
  const handleSelect = (val: string) => {
    onChange?.(val)
  }

  // 直接输入也能回写到表单
  const handleChange = (val: string) => {
    onChange?.(val)
  }

  // 关闭下拉时重置候选数据
  const handleDropdownVisibleChange = (open: boolean) => {
    if (!open) {
      dispatch({ type: 'reset' })
    }
  }

  return (
    <AutoComplete
      style={style}
      value={value}
      disabled={disabled}
      allowClear
      placeholder={placeholder}
      options={options}
      onSearch={debouncedSearch}
      onChange={handleChange}
      onSelect={handleSelect}
      getPopupContainer={() => document.body}
      notFoundContent={loading && '加载中...'}
      onDropdownVisibleChange={handleDropdownVisibleChange}
      dropdownStyle={{ maxHeight: '400px', overflowY: 'auto' }}
      filterOption={false}
      maxLength={100}
    />
  )
}

export default BrandSelect
